import React from 'react';
import { Form } from '@ant-design/compatible';
import { Input, Select, Modal, message } from 'antd';
import { USER_EDIT_SUCCESS, USER_EDIT_ERROR } from './../../../../actions/User';

const FormItem = Form.Item;

class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
    };
  }

  /**
   * Action success & errors handling
   * @param prevProps - previous props from earlier state
   */
  componentDidUpdate(prevProps) {
    this.handleActionResponseNotifications(this.props.actionResponse);
  }

  /**
   * Handles notifications for the action response
   * @param actionResponse - the response of the action made
   */
  handleActionResponseNotifications(actionResponse) {
    if (actionResponse === null) {
      return;
    }

    switch (actionResponse.get('type')) {
      case USER_EDIT_ERROR:
        message.error('Der er opstået en fejl, prøv igen.');
        break;

      case USER_EDIT_SUCCESS:
        message.success('Brugeren blev redigeret.');
        this.handleCancel();
        break;

      default:
        break;
    }
    this.props.clearActionResponse();
  }

  /**
   * Validates & submits data to backend
   * @param e is the submit button.
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const { onEdit, getCompanyIdFromCompanyName } = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { username, name, password, company, authority } = values;
        const companyId = Number.isInteger(company)
          ? company
          : getCompanyIdFromCompanyName(company);
        const user = { id: this.props.user.id, username, password, name, companyId, authority };
        onEdit(user);
      }
    });
  };

  /**
   * Closes modal window.
   */
  handleCancel = () => {
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8, textAlign: 'left' },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Modal
        width={'50%'}
        visible={this.props.visible}
        title={'Rediger bruger'}
        okText={'Ok'}
        cancelText={'Annuller'}
        onCancel={this.handleCancel}
        onOk={this.handleSubmit}
        confirmLoading={this.props.isLoading}
      >
        <Form>
          <FormItem {...formItemLayout} label={'Navn'}>
            {getFieldDecorator('name', {
              initialValue: this.props.user.name,
              rules: [
                {
                  required: true,
                  message: 'Navn skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Email'}>
            {getFieldDecorator('username', {
              initialValue: this.props.user.username,
              rules: [
                {
                  type: 'email',
                  message: 'Email-adressen er ikke gyldig',
                },
                {
                  required: true,
                  message: 'Email skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label='Password'>
            {getFieldDecorator('password', {
              rules: [
                {
                  required: false,
                  message: 'Password skal udfyldes.',
                },
                {
                  validator: (rule, value, callback) =>
                    this.props.validateToNextPassword(rule, value, callback, this),
                },
              ],
            })(<Input type='password' />)}
          </FormItem>
          <FormItem {...formItemLayout} label='Bekræft Password'>
            {getFieldDecorator('confirm', {
              rules: [
                {
                  required: false,
                  message: 'Bekræft password skal udfyldes.',
                },
                {
                  validator: (rule, value, callback) =>
                    this.props.compareToFirstPassword(rule, value, callback, this.props.form),
                },
              ],
            })(<Input type='password' onBlur={(e) => this.props.handleConfirmBlur(e, this)} />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Virksomhed'}>
            {getFieldDecorator('company', {
              initialValue: this.props.user.company.name,
              rules: [
                {
                  required: true,
                  message: 'Virksomhed skal udfyldes',
                },
              ],
            })(
              this.props.companies.length > 1 && this.props.isAdmin ? (
                <Select showSearch={true} optionFilterProp={'children'}>
                  {this.props.companies}
                </Select>
              ) : (
                <Input disabled={true} />
              )
            )}
          </FormItem>
          <FormItem {...formItemLayout} label={'Rettigheder'}>
            {getFieldDecorator('authority', {
              initialValue: this.props.user.authority,
              rules: [
                {
                  required: true,
                  message: 'Rettigheder skal udfyldes',
                  whitespace: true,
                },
              ],
            })(
              this.props.userRoles.length > 1 && this.props.isAdmin ? (
                <Select>{this.props.userRoles}</Select>
              ) : (
                <Input disabled={true} />
              )
            )}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(EditForm);
